var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09298 0.843097H10.6254L5.06328 6.40639L1.56256 1.93855C1.43641 1.7923 1.39054 1.62597 1.42208 1.43957C1.45361 1.25317 1.53676 1.10692 1.67151 1.00082C1.80627 0.894715 1.94675 0.843097 2.09298 0.843097ZM0 13.1598L13.1571 0L14 0.843097L8.40631 6.43794L8.09379 6.84515V10.7538C8.11386 10.9631 8.04219 11.1495 7.8759 11.3159L6.56277 12.6608C6.41655 12.787 6.25599 12.8472 6.07823 12.8472C5.90047 12.8472 5.73991 12.7784 5.59369 12.6436C5.44747 12.5088 5.38439 12.3253 5.40733 12.0959V9.43753L0.845792 14L0.00286709 13.1569L0 13.1598Z",
    fill: "#64A0E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.df319a5b3fdd36b9e72d965bf0e4283b.svg";
export { ForwardRef as ReactComponent };